module.exports = __webpack_public_path__ + "static/media/no_photo.606649ce.png";